export const COLUMNS = [
  {
    Header: 'Id',
    accessor: 'id'
  },
  {
    Header: 'Category',
    accessor: 'category'
  },
  {
    Header: 'Stock',
    accessor: 'stock'
  },
]